module.exports = __webpack_public_path__ + "static/media/135.205ce301.png";